import { Component, OnInit } from '@angular/core';
import { PasswordService } from '../services/password.service';
import { UserService } from '../services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from 'src/app/shared/services/globals';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-send-email-confirmation',
  templateUrl: './send-email-confirmation.component.html',
  styleUrls: ['./send-email-confirmation.component.css']
})
export class SendEmailConfirmationComponent implements OnInit {

  constructor( public passwordService: PasswordService,private userService: UserService, private router: Router,
               private global: Globals, private currentRoute: ActivatedRoute, translate: TranslateService) {

    translate.setDefaultLang('AR');

   }

  ngOnInit() {
  }

}
